import { render, staticRenderFns } from "./Map4.vue?vue&type=template&id=6a48489b&scoped=true"
import script from "./Map4.vue?vue&type=script&lang=js"
export * from "./Map4.vue?vue&type=script&lang=js"
import style0 from "./Map4.vue?vue&type=style&index=0&id=6a48489b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a48489b",
  null
  
)

export default component.exports